import { usePaywallCheckoutContext } from "@circle-react/contexts/Paywalls/paywallCheckoutContext";
import { classNames } from "@circle-react/helpers/twMergeWithCN";

import { AttemptsProvider } from "./AttemptsProvider/AttemptsProvider";
import { CheckoutDescription } from "./CheckoutDescription";
import { CheckoutForm } from "./CheckoutForm";
import { PricePreview } from "./CheckoutForm/PricePreview";
import { MobileFixedOnTopPreview } from "./CheckoutForm/PricePreview/ModalPreview/MobileFixedOnTopPreview";
import { GridColumns } from "./components/GridColumns";
import { SSOLoginPrompt } from "./SSOLoginPrompt";

export const CheckoutPage = Object.assign(
  () => {
    const { authProviderProperties } = usePaywallCheckoutContext();
    return (
      <main className="flex h-full flex-col">
        {!authProviderProperties?.is_sso_authentication_required && (
          <PricePreview variant="mobile_fixed_on_top" />
        )}
        <GridColumns
          className={classNames(
            "bg-primary h-full gap-y-6 *:px-5 md:gap-y-10 md:pt-0",
            {
              "pt-12 *:lg:pt-0":
                !authProviderProperties?.is_sso_authentication_required,
            },
          )}
          dataTestId="paywall-checkout-container"
        >
          <CheckoutDescription className="!bg-secondary pb-8 md:pb-10 xl:pr-28" />
          <SSOLoginPrompt className="xl:pl-28" />
          <AttemptsProvider>
            <CheckoutForm className="bg-primary pb-8 xl:pl-28" />
          </AttemptsProvider>
        </GridColumns>
      </main>
    );
  },
  {
    Skeleton: () => (
      <main className="flex h-full flex-col">
        <MobileFixedOnTopPreview.Skeleton />
        <GridColumns
          className={classNames(
            "bg-primary h-full gap-y-6 *:px-5 md:gap-y-10 md:pt-0",
          )}
          dataTestId="paywall-checkout-container"
        >
          <CheckoutDescription.Skeleton className="!bg-secondary pb-8 md:pb-10 xl:pr-28" />
          <CheckoutForm.Skeleton className="bg-primary pb-8 xl:pl-28" />
        </GridColumns>
      </main>
    ),
  },
);
